import { EntityRepository, Repository } from "typeorm";
import { ContainerLog } from "../container-log.entity";

@EntityRepository(ContainerLog)
export class ContainerLogRepository extends Repository<ContainerLog> {
    async getContainerReportData(): Promise<{ unit_id: number, status: string, qty: number }[]> {
        return await this.createQueryBuilder('container_log')
            .select('container.unit_id,container_log.status,count(*) as qty')
            .leftJoin('container_log.containerInfo', 'container')
            .groupBy('container.unit_id,container_log.status')
            .getRawMany()
    }
}